const Pricing = {

    // FIELDS
    "category": "Category",
    "effective_date": "Effective Date",
    "search": "Search",

    // PAGE HEADER
    "pricing": "Pricing",
    "pricing_configuration": "Pricing Configuration",

    // ERROR
    "error_category": "Select Category",
    "error_effective_date": "Select Effective Date",
    "error_filters": "Select Category and Effective Date",
    "error_price": "Enter Price greater than 0",
    "error_discount_non_negative": "Discount cannot be negative",
    "error_rows_required": "Select at least one product row to save pricing",
    "no_products_found": "No products found for selected filters",

    // TABLE HEADER
    "table_last_effective": "LAST EFFECTIVE",
    "table_product": "PRODUCT",
    "table_variant": "VARIANT",
    "table_price": "PRICE",
    "table_discount": "DISCOUNT (%)",
    "table_gst": "GST (%)",
    "table_effective_date": "EFFECTIVE DATE",

}

export default Pricing;